import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

let params;

function init() {
    $(document).on("click", "#deleteAreabtn", function() {
        const areaId = $(this)
            .closest("tr").attr("areaId");
        const personId = $("#personId").val();
        const container = $("#areas");
        params = {
            url: "/api/area/deletearea/" + areaId + "/" + personId
        };
        dataaccess.post(params).done(function(result) {
            container.html(result);
        });
    });
}

export const areaTable = {
    init: init
};
